import getCurrencySymbol from "utils/get-currency-symbol"

const currencySymbol = getCurrencySymbol()

export default currencySymbol
